import { CanActivateFn, Router, NavigationExtras } from '@angular/router';
import { LocalstorageService } from '../providers/localstorage.service';
import { inject } from '@angular/core';
import { LoginUser } from '../models/user';
import { routingPath } from '../models/constants';

export const mainrouteGuard: CanActivateFn = async (route, state) => {
  const lsService = inject(LocalstorageService);
  const router = inject(Router);
  // const navParams: NavigationExtras = {
  //   queryParams: { returnUrl: state.url },
  // };
  let user:LoginUser = await lsService.getLoggedinUserData();
  if(user) {
    if(user?.mobile) {
      if(user?.userDetails) {
        // router.navigate([routingPath.dashboard], navParams);
        router.navigate([routingPath.dashboard]);
        return false;
      } else {
        // router.navigate([routingPath.registration], navParams);
        router.navigate([routingPath.registration]);
        return false;
      }
    } else {
      // router.navigate([routingPath.login], navParams);
      router.navigate([routingPath.login]);
      return false;
    }
  } else {
    // router.navigate([routingPath.introslides], navParams);
    router.navigate([routingPath.introslides]);
    return false;
  }
  return true;
};

